import { Flex, Img, Heading, Text, Stack } from "@chakra-ui/react";

const Currency = () => {
    return (
        <Stack bgColor="#002B5B" align="center" my="100px" >
            <Flex justifyContent="center" w="100%" maxW="1140px" flexDirection={{ base: "column", lg: "row" }} gap="10vw" fontWeight="300" fontSize="35px" color="white" width="100%" h={{ base: "auto", lg: "200px" }} alignContent="center" pt={{ base: "50px", lg: "0" }}>
                <Flex minW="217px" justifyContent="center" alignItems="center">
                    <Heading fontSize="40px" fontWeight="300" pb={{ base: "30px", md: "0" }}>We Accept: </Heading>
                </Flex>
                <Flex alignItems="center" direction="column" position="relative" bottom="50px">
                    <Img src="https://redswan.io/wp-content/uploads/2023/03/USD.png" w="189px" />
                    <Text>USD</Text>
                </Flex>
                <Flex alignItems="center" direction="column" position="relative" bottom="50px">
                    <Img src="https://redswan.io/wp-content/uploads/2023/03/usdc.png" w="189px" />
                    <Text>USDC</Text>
                </Flex>
            </Flex>
        </Stack>
    );
}

export default Currency;